import BottomNav from '../components/BottomNav';
import styles from './CardsScreen.module.css';

const CardsScreen = () => {
  return (
    <div className={styles.screen}>
      <div className={styles.content}>
        <h1 className={styles.heading}>Cards</h1>

        <div className={styles.illustration}>
          <div className={styles.cardBack} />
          <div className={styles.cardFront}>
            <div className={styles.cardChip}>
              <div className={styles.chipInner} />
            </div>
            <div className={styles.cardNumber}>•••• •••• •••• 4892</div>
            <div className={styles.cardRow}>
              <div>
                <p className={styles.cardFieldLabel}>Card holder</p>
                <p className={styles.cardFieldValue}>Sebin M.</p>
              </div>
              <div>
                <p className={styles.cardFieldLabel}>Expires</p>
                <p className={styles.cardFieldValue}>09/28</p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.textBlock}>
          <p className={styles.title}>Coming soon</p>
          <p className={styles.sub}>
            Manage your virtual and physical cards, set spending limits, and freeze cards instantly.
          </p>
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default CardsScreen;
